import { render, staticRenderFns } from "./tipsDetail.vue?vue&type=template&id=496d109e"
import script from "./tipsDetail.vue?vue&type=script&lang=js"
export * from "./tipsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports